import type { SelectItem } from '@/_components';
import type { PreferredSignInMethod } from '@/_types/auth';

export const PREFERRED_SIGN_IN_METHODS = [
  'password',
  'email',
  'sms',
] as Array<PreferredSignInMethod>;

export const PREFERRED_SIGN_IN_METHOD_MAP: Record<
  PreferredSignInMethod,
  string
> = {
  password: 'Password',
  email: 'Email',
  sms: 'Text',
};

export const PREFERRED_SIGN_IN_METHOD_ITEMS: Array<SelectItem> =
  PREFERRED_SIGN_IN_METHODS.map((item) => ({
    name: PREFERRED_SIGN_IN_METHOD_MAP[item],
    value: item,
  }));

export const FALLBACK_SIGN_IN_METHOD: PreferredSignInMethod = 'email';
